/* Tracker Data Retrieval Service
 *
 * Angular module: trackerbase-app.services.tracker-data-service
 * Injected Service: TrackerData
 *
 */

import angular from "angular";

import Assert from "tbAssert";
import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

import Tracker from "../models/Tracker";

const mHttpSvc = new WeakMap();
const mQSvc = new WeakMap();
const mLogSvc = new WeakMap();

const mTrackerDataBaseUrl = new WeakMap();

class TrackerDataService {
    constructor($http, $q, $log, TbAppConfigDataService) {
        Assert.StrictAssert($http != null, "Assertion Failure: Missing Http Service Dependency");
        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");

        mHttpSvc.set(this, $http);
        mQSvc.set(this, $q);
        mLogSvc.set(this, $log);
        mTrackerDataBaseUrl.set(this, `${TbAppConfigDataService.tbServerBaseUrl}/api/trackers`);
    }

    toString() {
        return `Tracker Data Service (${mTrackerDataBaseUrl.get(this)})`;
    }

    getTracker(trackerId) {
        let idUrl = `${mTrackerDataBaseUrl.get(this)}/${trackerId}`;

        let queryResultPromise = mHttpSvc.get(this)({
            method: "GET",
            url: idUrl,
            isArray: false
        })
        .then(
            (response) => {
                if ((response != null) && (response.data != null)) {
                    let serverTracker = response.data;
                    let retrievedTracker = Tracker.FromServerTracker(serverTracker);

                    return retrievedTracker;
                }
                else {
                    return mQSvc.get(this).reject("No tracker data in response");
                }
            },
            (errorResponse) => {
                return mQSvc.get(this).reject(errorResponse);
            }
        );

        return queryResultPromise;
    }

    getTrackerBatch(trackerIds) {
        if ((trackerIds != null) && (trackerIds.length > 0)) {
            let trackerIdPromises = trackerIds.map((trackerId) => this.getTracker(trackerId));
            return mQSvc.get(this).all(trackerIdPromises);
        }
        else {
            return mQSvc.get(this).when([]);
        }
    }

    search(lastNameSearch, activeOnly) {
        let queryStringParts = [];

        if ((lastNameSearch != null) &&
            (angular.isString(lastNameSearch)) &&
            (lastNameSearch.length > 0))
        {
            queryStringParts.push("lastname|" + lastNameSearch);
        }

        if ((activeOnly != null) &&
            (typeof(activeOnly) === "boolean"))
        {
            queryStringParts.push("isactive|" + activeOnly.toString());
        }

        if (queryStringParts.length === 0) {
            mLogSvc.get(this).debug("Cannot make search requests without a filter.");
            return mQSvc.get(this).when({ trackerData: [] });
        }

        if (queryStringParts.length === 2) {
            queryStringParts.unshift("and");
        }

        let queryString = queryStringParts.join("||");

        let queryResultPromise = mHttpSvc.get(this)({
            method: "GET",
            url: `${mTrackerDataBaseUrl.get(this)}/search`,
            params: { q: queryString },
            isArray: false
        })
        .then(
            (queryResultData) => {
                if (queryResultData.data != null) {
                    let queryResult = {
                        total: queryResultData.data.TotalItems,
                        trackerData: queryResultData.data.Items.map(
                            (serverTracker) => Tracker.FromServerTracker(serverTracker)
                        )
                    };

                    return queryResult;
                }
                else {
                    return mQSvc.get(this).reject("Response contained no data");
                }
            },
            (errorResponse) => mQSvc.get(this).reject(errorResponse)
        );

        return queryResultPromise;
    }
}

TrackerDataService.$inject = [
    "$http",
    "$q",
    "$log",
    "TbAppConfigDataService"
];

export default angular
    .module("trackerbase-app.services.tracker-data-service",[
        TbAppConfigDataServiceModule
    ])
    .service("TrackerData", TrackerDataService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/TrackerDataService.js
// module id = IXBa
// module chunks = 1